
export const getPost = (state) => state.post